module.exports = __webpack_public_path__ + "static/media/trial1_3.54e4e08c.png";